import { render, staticRenderFns } from "./BottomNavigationCard.vue?vue&type=template&id=f726879a&scoped=true"
import script from "./BottomNavigationCard.vue?vue&type=script&lang=js"
export * from "./BottomNavigationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f726879a",
  null
  
)

export default component.exports